import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type {
	DDSEmotionEntry,
	DDSEmotionListOutput,
	DDSEmotionListParams,
} from '@/types'
import { getDDSEmotions, registerMoodAction } from '../services/dds-emotions'

const EMOTIONS_KEY = ['dds-emotions']

export function useDDSEmotions(params?: DDSEmotionListParams) {
	return useQuery<DDSEmotionListOutput, Error>({
		queryKey: [...EMOTIONS_KEY, params],
		queryFn: () => getDDSEmotions(params),
		staleTime: 0,
	})
}

interface RegisterMoodActionVariables {
	ddsId: string
	attendeeId: string
	action: string
}

export function useRegisterMoodAction() {
	const queryClient = useQueryClient()
	return useMutation<DDSEmotionEntry, Error, RegisterMoodActionVariables>({
		mutationFn: ({ ddsId, attendeeId, action }) =>
			registerMoodAction(ddsId, attendeeId, action),
		onSuccess: (_entry, { ddsId }) => {
			queryClient.invalidateQueries({ queryKey: EMOTIONS_KEY })
			queryClient.invalidateQueries({ queryKey: ['dds', ddsId, 'attendance'] })
		},
	})
}
